import {UserShortInfo} from './UserShortInfo';

/**
 * @export
 * @type EmailDeliveryLog
 */
export type EmailDeliveryLog = {
    id: number;
    email: string;
    status: EmailDeliveryLogStatus;
    statusChangeDate?: string;
    initiatorUser: UserShortInfo;
}

export enum EmailDeliveryLogStatus {
    PROCESSED = 'PROCESSED',
    DEFERRED = 'DEFERRED',
    DELIVERED = 'DELIVERED',
    BOUNCE = 'BOUNCE',
    DROPPED = 'DROPPED'
}